import {
  SEARCH_MEMBERS_REQUEST,
  SEARCH_MEMBERS_SUCCESS,
  SEARCH_MEMBERS_FAILURE,
  SEARCH_MEMBERS_CLEAR,
  SELECT_MEMBER_RESULT,
  FETCH_MEMBER_AGGREGATES_REQUEST,
  FETCH_MEMBER_AGGREGATES_SUCCESS,
  FETCH_MEMBER_AGGREGATES_FAILURE,
  CLEAR_MEMBER_AGGREGATES,
} from '../actions/member_search_index';

const initialState = {
  query: '',
  results: [],
  loading: false,
  expandedMemberId: null,
  aggregates: [],
  aggregatesLoading: false,
  requestId: 0,
};

export default function memberSearchReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_MEMBERS_REQUEST:
      return {
        ...state,
        loading: true,
        expandedMemberId: null,
        aggregates: [],
        aggregatesLoading: false,
        requestId: state.requestId + 1,
      };

    case SEARCH_MEMBERS_SUCCESS:
      return { ...state, loading: false, results: action.payload };

    case SEARCH_MEMBERS_FAILURE:
      return { ...state, loading: false, results: [] };

    case SEARCH_MEMBERS_CLEAR:
      return { ...initialState, requestId: state.requestId + 1 };

    case SELECT_MEMBER_RESULT:
      return { ...state, results: [], query: '', expandedMemberId: null, aggregates: [] };

    case FETCH_MEMBER_AGGREGATES_REQUEST:
      return { ...state, expandedMemberId: action.payload.memberId, aggregates: [], aggregatesLoading: true };

    case FETCH_MEMBER_AGGREGATES_SUCCESS:
      return { ...state, aggregatesLoading: false, aggregates: action.payload };

    case FETCH_MEMBER_AGGREGATES_FAILURE:
      return { ...state, aggregatesLoading: false, aggregates: [] };

    case CLEAR_MEMBER_AGGREGATES:
      return { ...state, expandedMemberId: null, aggregates: [], aggregatesLoading: false };

    default:
      return state;
  }
}
